import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default function NoBlock(props) {
  return (
    <SvgIcon {...props}>
      <path
        style={{ fill: 'black' }}
        d="M12.1,2.4l9.9,4v1.3h-1.3c0,.2,0,.3-.2.5-.1.1-.3.2-.5.2H4.1c-.2,0-.4,0-.5-.2-.1-.1-.2-.3-.2-.5h-1.3v-1.3l9.9-4ZM4.8,9.1h2.7v8h1.3v-8h2.7v8h1.3v-8h2.7v8h1.3v-8h2.7v8h.6c.2,0,.4,0,.5.2.1.1.2.3.2.5v.7H3.4v-.7c0-.2,0-.3.2-.5.1-.1.3-.2.5-.2h.6v-8h0ZM21.3,19c.2,0,.4,0,.5.2.1.1.2.3.2.5v1.3H2.1v-1.3c0-.2,0-.3.2-.5.1-.1.3-.2.5-.2h18.5,0Z"
      />
    </SvgIcon>
  );
}
